export default "\r\n  <ngx-spinner></ngx-spinner>\r\n\r\n    <router-outlet></router-outlet>\r\n  \r\n\r\n"